<template>
	<div class="border-top">
		<div class="p-x-20 p-y-16 w-100 d-flex-between-center" :id="id">
			<div class="f-semi f-16">
				Tampilkan <b>2 Workshop</b> Tersembunyi
			</div>
			<SOInputOnOff :checkboxes="workshopTersembunyi" @selected="selected" />
		</div>
		<div class="separator"></div>
	</div>
</template>

<script>
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputOnOff from "@/so-components/global/input/SOInputOnOff";

export default {
	name: "SOFilterWorkshopNonaktif",
	components: {
		SOFilterTitle,
		SOInputOnOff,
	},
	props: {
		id: String,
	},
	data() {
		return {
			workshopTersembunyi: {
				name: "workshop-tersembunyi",
				data: [
					{
						id: "fow-1",
						value: "1",
						title: "",
						checked: false,
						titleBold: false,
					},
				]
			},
		}
	},
	methods: {
		selected(val) {
			this.$emit("selected", val);
		}
	}
}
</script>